import { render, staticRenderFns, recyclableRender, components } from "./cuisineItem.vue?vue&type=template&id=5f2d6ad0&scoped=true&"
var renderjs
import script from "./cuisineItem.vue?vue&type=script&lang=js&"
export * from "./cuisineItem.vue?vue&type=script&lang=js&"
import style0 from "./cuisineItem.vue?vue&type=style&index=0&id=5f2d6ad0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../soft/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f2d6ad0",
  null,
  false,
  components,
  renderjs
)

component.options.__file = "pages/merchant/merchatCenter/cuisineManger/cuisineItem.vue"
export default component.exports